module.exports = __webpack_public_path__ + "static/media/newLife1.f5cdcdf1.jpg";